import * as types from "./action-types";

import firebase from "firebase/app";
import * as fb from "../../firebase/firebasejs";

import "firebase/firestore";
import { store } from "../configureStore";
import { showSnackbar } from "./atlete-actions";



//###########################################################################
export function listenToGameEvents(gameId) {
  return (dispatch) => {
    console.log("📡 Escuchando eventos del partido:", gameId);

    const unsubscribe = fb.firestore
      .collection("teamGames")
      .doc("basketball")
      .collection("partidos")
      .doc(gameId)
      .collection("eventos")
      .orderBy("timestamp", "asc")
      .onSnapshot(
        (snapshot) => {
          const list = snapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));

          dispatch({
            type: types.GAME_EVENTS,
            gameEvents: list,
          });
        },
        (error) => {
          console.error("❌ Error escuchando eventos:", error);
          dispatch({
            type: types.GAME_EVENTS_ERROR,
            error: error.message,
          });
        }

      );

    // ✅ Devuelve la función de limpieza
    return unsubscribe;
  };
}
//###########################################################################

export function listenToGameData(gameId) {
  return (dispatch) => {
    console.log("📡 Escuchando cambios del partido:", gameId);

    const unsubscribe = fb.firestore
      .collection("teamGames")
      .doc("basketball")
      .collection("partidos")
      .doc(gameId)
      .onSnapshot(
        (snapshot) => {
          if (snapshot.exists) {
            dispatch({
              type: types.GAME_DATA,
              gameData: snapshot.data(),
            });
          } else {
            console.warn("⚠️ El documento no existe:", gameId);
          }
        },
        (error) => {
          console.error("❌ Error escuchando partido:", error);
          dispatch({
            type: types.GAME_DATA_ERROR,
            error: error.message,
          });
        }
      );

    // ✅ Devuelve la función para detener el listener cuando el componente se desmonte
    return unsubscribe;
  };
}
//###########################################################################
export function saveGameData(gameId, data) {
  return async (dispatch) => {
    dispatch({ type: types.GAME_SAVE_REQUEST });

    try {
      const ref = fb.firestore
        .collection("teamGames")
        .doc("basketball")
        .collection("partidos")
        .doc(gameId);

      // Usamos set con merge para no borrar campos existentes
      await ref.set(
        {
          ...data
        },
        { merge: true }
      );

      dispatch({
        type: types.GAME_SAVE_SUCCESS,
        payload: data,
      });
    } catch (error) {
      console.error("Error guardando datos del partido:", error);
      dispatch({
        type: types.GAME_SAVE_ERROR,
        error: error.message,
      });
    }
  };
}

//###########################################################################
// 🔹 Obtener lista de juegos de basket creados por un usuario
export const fetchUserBasketGames = (userId) => async (dispatch) => {
  console.log("fetchUserBasketGames");
  dispatch({ type: types.BASKET_GAMES_LOADING });

  try {
    const snapshot = await firebase
      .firestore()
      .collection("teamGames")
      .doc("basketball")
      .collection("partidos")
      .where("ownerId", "==", userId)
      .get();

    const games = snapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    dispatch({ type: types.BASKET_GAMES_SET, payload: games });
  } catch (error) {
    dispatch({
      type: types.BASKET_GAMES_ERROR,
      payload: error.message,
    });
  }
};

//###########################################################################

// 🔹 Crear un nuevo juego de basket para el usuario
export const createBasketGame = ({ userId, name = "Nuevo Juego" }) => async (dispatch) => {
  dispatch({ type: types.BASKET_GAMES_LOADING });

  try {
    const newGame = {
      ownerId: userId,
      name,
      createdAt: firebase.firestore.FieldValue.serverTimestamp(),
      status: "draft",
      estado: {

        teamAInfo: {
          name: "Equipo A",
          coach: "Vacio",
          players: [],
        },
        teamBInfo: {
          name: "Equipo B",
          coach: "Vacio",
          players: [],
        },
      }

    };

    const docRef = await firebase.firestore().collection("teamGames")
      .doc("basketball")
      .collection("partidos")
      .add(newGame);

    dispatch({
      type: types.BASKET_GAMES_ADD,
      payload: { id: docRef.id, ...newGame },
    });
  } catch (error) {
    dispatch({
      type: types.BASKET_GAMES_ERROR,
      payload: error.message,
    });
  }
};
